<form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12" novalidate style="max-width: 1200px">
  <app-form-date-input [form]="form" [twoColumns]="true" id="validFrom" label="GLOBAL.GUELTIG_AB"></app-form-date-input>

  <app-form-date-input [form]="form" [twoColumns]="true" id="validTo" label="GLOBAL.GUELTIG_BIS"></app-form-date-input>

  <app-form-number-input
    (onFocus)="onFocus($event)"
    [form]="form"
    [max]="100"
    [maxFractionDigits]="0"
    [min]="0"
    [minFractionDigits]="0"
    [twoColumns]="true"
    id="timeAllowancePerHourInPercent"
    label="TIME_CREDITS.TIME_CREDIT_PER_HOUR_IN_PERCENT"></app-form-number-input>

  <app-form-number-input
    (onFocus)="onFocus($event)"
    [form]="form"
    [max]="60"
    [maxFractionDigits]="0"
    [min]="0"
    [minFractionDigits]="0"
    [twoColumns]="true"
    id="timeAllowancePerHourInMinutes"
    label="TIME_CREDITS.TIME_CREDIT_PER_HOUR_IN_MINUTES"></app-form-number-input>

  @for (weekDay of weekDays; track weekDay.lateShiftId; let i = $index) {
    <app-form-number-input
      (onFocus)="onFocus($event)"
      [form]="form"
      [id]="weekDay.lateShiftId"
      [label]="weekDay.lateShiftLabel"
      [maxFractionDigits]="2"
      [minFractionDigits]="1"
      [twoColumns]="true"></app-form-number-input>
    <app-form-number-input
      (onFocus)="onFocus($event)"
      [form]="form"
      [id]="weekDay.nightShiftId"
      [label]="weekDay.nightShiftLabel"
      [maxFractionDigits]="2"
      [minFractionDigits]="1"
      [twoColumns]="true"></app-form-number-input>
  }

  <app-form-number-input
    [form]="form"
    [maxFractionDigits]="2"
    [minFractionDigits]="1"
    [twoColumns]="true"
    id="perWeek"
    label="TIME_CREDITS.PER_WEEK"></app-form-number-input>
  <app-form-number-input
    [form]="form"
    [maxFractionDigits]="2"
    [minFractionDigits]="1"
    [twoColumns]="true"
    id="perYear"
    label="TIME_CREDITS.PER_YEAR"></app-form-number-input>
  <app-form-number-input
    [form]="form"
    [maxFractionDigits]="2"
    [minFractionDigits]="1"
    [twoColumns]="true"
    id="totalPerYear"
    label="TIME_CREDITS.TOTAL_PER_YEAR"></app-form-number-input>

  <app-form-button-bar (onCancel)="onCancel()" [form]="form"></app-form-button-bar>
</form>
